import * as React from "react";
import { AccountConversion } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/AccountConversion";
import { ConvertCappedToFlexiModel } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/ConvertCappedToFlexiModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { AccountsConversionTable } from "../../Common/ConvertCappedToFlexi/AccountsConversionTable";
import { FlexiIncomeReview } from "../../Common/ConvertCappedToFlexi/FlexiIncomeReview";
import { ImportantInformation } from "../../Common/ConvertCappedToFlexi/ImportantInformation";
import { convertToFlexiStepperName } from "../Resource/Content";

interface ISelectArrangementProps extends IProcessComponentProps {}

interface ISelectArrangementState {}

export class SelectArrangement extends ProcessComponent<ISelectArrangementProps, ISelectArrangementState> {
    constructor(props: any) {
        super(props);
        this.state = { showImportantInformationPopUp: false };
    }

    isValid() {
        const data: ConvertCappedToFlexiModel = this.props.data;
        const selectedArrangements = data.Conversion.filter(
            (arrangement) => arrangement.AccountDetails.IsSelected == true
        );
        if (selectedArrangements.length == 0) {
            this.props.showErrorMsgPopUp(["Please select an arrangement to continue."], true);
        }
        return super.isValid() && selectedArrangements.length > 0;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                <h2 className="mb-18">
                    <span>{convertToFlexiStepperName.selectArrangement}</span>
                </h2>
                <ImportantInformation data={data} onChange={() => {}} onRef={(ref) => this.appendChild(ref)} />
                <AccountsConversionTable
                    data={data.Conversion}
                    onChange={(v) => {
                        this.onSelectionChange(v);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    isReviewStep={false}
                    isReview={this.props.isReview}
                />
                <FlexiIncomeReview
                    data={data.FlexiIncomeReview}
                    onChange={(v) => this.onDataChange(onChange, v, data, "FlexiIncomeReview")}
                    onRef={(ref) => this.appendChild(ref)}
                />
            </>
        );
    }

    private onSelectionChange(data: Array<AccountConversion>) {
        const selectedArrangements = data.filter((a) => a.AccountDetails.IsSelected == true);
        this.props.onChange({
            Conversion: data,
            ArrangementHierarchyIds: selectedArrangements.map((a) => a.AccountDetails.HierarchyId),
        });
    }
}
